var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HomePage'),_c('transition',{attrs:{"name":"rule"}},[(_vm.isShowRulePop)?_c('RulePop'):_vm._e()],1),_c('transition',{attrs:{"name":"qr"}},[(_vm.isShowQrPop)?_c('QrPop'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }